module.exports = __webpack_public_path__ + "img/max@2x.54d48410.png";